import * as consts from "../consts";

export function cardIssues(cardBuilderSettings) {
  let errors = [];
  let cardDetails = [...cardBuilderSettings.cardDetails];
  errors = [...errors, cardValueIssues(cardBuilderSettings.cardValue, true)];
  if (cardDetails.length > 0 && cardBuilderSettings.cardImage.length > 0) {
    cardDetails.map((cardDetail, index) => {
      errors = [...errors, fromIssues(cardDetail.from, true)];
      errors = [...errors, toIssues(cardDetail.to, true)];
      switch (cardBuilderSettings.cardType) {
        case consts.CARD_TYPE_PLASTIC:
          errors = [...errors, plasticMessageIssues(cardDetail.message, true)];
          if (
            cardBuilderSettings.mailOption == consts.PLASTIC_TYPE_THEM ||
            index == 0
          ) {
            if (cardDetail.shipping) {
              errors = [...errors, nameIssues(cardDetail.shipping.name, true)];
              errors = [
                ...errors,
                companyIssues(cardDetail.shipping.company, true),
              ];
              errors = [
                ...errors,
                addressIssues(cardDetail.shipping.address, true),
              ];
              errors = [...errors, cityIssues(cardDetail.shipping.city, true)];
              errors = [
                ...errors,
                stateIssues(cardDetail.shipping.state, true),
              ];
              errors = [...errors, zipIssues(cardDetail.shipping.zip, true)];
            } else {
              errors = ["Must have a valid shipping address"];
            }
          }
          break;
        case consts.CARD_TYPE_EMAIL:
          errors = [...errors, emailIssues(cardDetail.email, true)];
          errors = [...errors, emailMessageIssues(cardDetail.message, true)];
          if (cardDetail.emailOption == consts.EMAIL_TYPE_LATER) {
            errors = [
              ...errors,
              deliveryDateIssues(cardDetail.deliveryDate, true),
            ];
          }
          break;
        case consts.CARD_TYPE_PRINTER:
          errors = [...errors, printerMessageIssues(cardDetail.message, true)];
          break;
      }
    });
  } else {
    errors = [
      "Must have at least one card with a selected image to add to cart",
    ];
  }
  errors = errors.filter(Boolean);
  return errors;
}

export function cardValueIssues(cardValue, validate) {
  if (validate) {
    if (cardValue && !isNaN(parseFloat(cardValue))) {
      if (cardValue < consts.MIN_CARD_VALUE) {
        return `Enter a value of $${consts.MIN_CARD_VALUE} or more`;
      } else if (cardValue > consts.MAX_CARD_VALUE) {
        return `Enter a value of $${consts.MAX_CARD_VALUE} or less`;
      } else {
        return null;
      }
    } else {
      return `Card value is required`;
    }
  } else {
    return null;
  }
}

export function shippingAddressIssues(cardBuilderSettings, cart) {
  let addressIssues = null;
  if (
    cardBuilderSettings.cardType == consts.CARD_TYPE_PLASTIC &&
    cardBuilderSettings.mailOption == consts.PLASTIC_TYPE_ME
  ) {
    cart.map((cartItem) => {
      if (
        cartItem.cardType == consts.CARD_TYPE_PLASTIC &&
        cartItem.mailOption == consts.PLASTIC_TYPE_ME
      ) {
        cartItem.cardDetails.map((cardDetail) => {
          if (
            cartItem.cartItemID != cardBuilderSettings.cartItemID &&
            (cardDetail.shipping.name !=
              cardBuilderSettings.cardDetails[0].shipping.name ||
              cardDetail.shipping.company !=
                cardBuilderSettings.cardDetails[0].shipping.company ||
              cardDetail.shipping.address !=
                cardBuilderSettings.cardDetails[0].shipping.address ||
              cardDetail.shipping.city !=
                cardBuilderSettings.cardDetails[0].shipping.city ||
              cardDetail.shipping.state !=
                cardBuilderSettings.cardDetails[0].shipping.state ||
              cardDetail.shipping.zip !=
                cardBuilderSettings.cardDetails[0].shipping.zip)
          ) {
            addressIssues = "Shipping address conflict.";
          }
        });
      }
    });
  }

  return addressIssues;
}

export function emailMessageIssues(message, validate) {
  if (validate) {
    if (message && message.length > 900) {
      return "Message must be less than 900 characters";
    } else {
      return null;
    }
  } else {
    return null;
  }
}

export function plasticMessageIssues(message, validate) {
  if (validate) {
    if (message && message.length > 550) {
      return "Message must be less than 550 characters";
    } else {
      return null;
    }
  } else {
    return null;
  }
}

export function printerMessageIssues(message, validate) {
  if (validate) {
    if (message && message.length > 550) {
      return "Message must be less than 550 characters";
    } else {
      return null;
    }
  } else {
    return null;
  }
}

export function fromIssues(from, validate) {
  if (validate) {
    return null;
  } else {
    return null;
  }
}

export function toIssues(to, validate) {
  if (validate) {
    return null;
  } else {
    return null;
  }
}

export function companyIssues(company, validate) {
  if (validate) {
    return null;
  } else {
    return null;
  }
}

export function nameIssues(name, validate) {
  if (validate) {
    if (!name || name.length == 0) {
      return "Name is required";
    } else {
      return null;
    }
  } else {
    return null;
  }
}

export function addressIssues(address, validate) {
  if (validate) {
    if (!address || address.length == 0) {
      return "Address is required";
    } else {
      return null;
    }
  } else {
    return null;
  }
}

export function cityIssues(city, validate) {
  if (validate) {
    if (!city || city.length == 0) {
      return "City is required";
    } else {
      return null;
    }
  } else {
    return null;
  }
}

export function stateIssues(state, validate) {
  if (validate) {
    if (!state || state.length == 0 || state == "SELECT") {
      return "State is required";
    } else {
      return null;
    }
  } else {
    return null;
  }
}

export function zipIssues(zip, validate) {
  if (validate) {
    if (!zip || zip.length == 0) {
      return "Zip is required";
    } else {
      if (!consts.VALIDATION_ZIP.test(zip)) {
        return "Not a valid zip code";
      } else {
        return null;
      }
    }
  } else {
    return null;
  }
}

export function emailIssues(email, validate) {
  if (validate) {
    if (!email || email.length == 0) {
      return "Email is required";
    } else if (!consts.VALIDATION_EMAIL.test(email)) {
      return "Not a valid email address";
    } else {
      return null;
    }
  } else {
    return null;
  }
}

export function deliveryDateIssues(deliveryDate, validate) {
  if (validate) {
    let date = new Date(deliveryDate);
    if (!deliveryDate || deliveryDate.length == 0) {
      return "Delivery date is required";
    } else if (date < new Date()) {
      return "Delivery date must be in the future";
    } else {
      return null;
    }
  } else {
    return null;
  }
}
